export default __webpack_public_path__ + "static/enterprise-ready-fef30d04d105c8e969622b4b8bbbf9e8.png";